import { useQueryClient } from 'react-query';
import { AxiosInstance } from 'axios';
import { useAuthMutation } from 'features/common/apiUtils/queryHelper';
import { groupsApiConfig } from 'features/user-groups/api';

const {
  update_delete_group: { scope, url },
  get_groups: { queryKey },
} = groupsApiConfig;

export function useDeleteOrgGroup() {
  const queryClient = useQueryClient();

  return useAuthMutation(
    (axiosInstance: AxiosInstance) => async (groupId: string) => {
      await axiosInstance.delete(url(groupId));
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(queryKey);
      },
    },
    scope,
  );
}
